export const levelRequirements: number[] = [
	10000, // 10000
	25000, // 35000
	45000, // 80000
	70000, // 150000
	100000, // 250000
	100000, // 350000
	100000, // 450000
	100000, // 550000
	100000, // 650000
	100000, // 750000
	100000, // 850000
	100000, // 950000
	100000, // 1050000
	100000, // 1150000
	100000, // 1250000
	100000, // 1350000
	100000, // 1450000
	100000, // 1550000
	100000, // 1650000
	100000, // 1750000

	100000, // 1850000
	100000, // 1950000
	100000, // 2050000
	100000, // 2150000
	100000, // 2250000
	100000, // 2350000

	100000, // 2450000
	100000, // 2550000
	100000, // 2650000
	100000, // 2750000
	100000, // 2850000
	100000, // 2950000
];

let exp = 0;
export const expRequirements: number[] = [0];
for (let i = 0; i < levelRequirements.length; i++) {
	exp += levelRequirements[i];
	expRequirements[i + 1] = exp;
}

export const maxExp = exp;
